module.exports = __webpack_public_path__ + "img/simb-mas-gris.7dc28010.svg";